<template>
  <div v-if="!pending" class="tailwind">
    <DestinationsLandingHero />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { DestinationsLandingHero } from '@common/lib-vue-common'
import { startUpLabels } from './composables/useLabels.js'

const pending = ref(true)
const sbConfig = ref()

onMounted(async () => {
  sbConfig.value = {
    allowedRateTypes: window?.appGlobalProps.specialRates || []
  }
  await startUpLabels()
  pending.value = false
})
</script>
